import moment from 'moment';
import {
    PTO_SETTING, PTO_TYPE_GET_LIST, PTO_TYPE_CREATE, PTO_TYPE_UPDATE, PTO_TYPE_DELETE,
    PTO_REASON_CREATE, PTO_REASON_DELETE, PTO_REASON_GET_LIST, PTO_REASON_UPDATE,
    HOLIDAY_CREATE, HOLIDAY_UPDATE, HOLIDAY_DELETE, HOLIDAY_GET_LIST,
    TIMEOFF_REQUEST_LIST, LEAVE_LIST, CREATE_TIMEOFF_REQUEST, 
    MODIFY_TIMEOFF_REQUEST, DELETE_TIMEOFF_REQUEST, BIRTHDAY_LIST,
    GET_PENDING_REQUESTS, GET_PENDING_REQUEST_DATA, UPDATE_PENDING_REQUESTS,
    USER_PTO_INFO_LIST, STAFF_PTO_INFO, USER_REQUEST_LIST, ASSIGNED_HOLIDAY_GET_LIST,
    HOLIDAY_CREATE_ASSIGNMENT, HOLIDAY_UPDATE_ASSIGNMENT,
    STAFF_ALLOWED_LIST, UPDATE_STAFF_ALLOWED_LIST,
    GET_BLACKOUT_DAY_LIST, POST_BLACKOUT_DAY, UPDATE_BLACKOUT_DAY, DELETE_BLACKOUT_DAY
} from './../actions/ActionTypes';
import InitialState from './InitialState';
import {WAITING_FOR_APPROVAL} from '../components/pto/Constants';

const PTOReducer = (state = InitialState.pto, action) => {
    const comparePTOType = (a, b) => {
        if (a.name.toUpperCase() < b.name.toUpperCase()) {
            return -1;
        }
        if (a.name.toUpperCase() > b.name.toUpperCase()) {
            return 1;
        }
        return 0;
    }

    const comparePTOReason = (a, b) => {
        if (a.reason.toUpperCase() < b.reason.toUpperCase()) {
            return -1;
        }
        if (a.reason.toUpperCase() > b.reason.toUpperCase()) {
            return 1;
        }
        return 0;
    }

    const compareDate = (a, b) => {
        const dateA = moment(a.occasion_date, "MM/DD/YYYY");
        const dateB = moment(b.occasion_date, "MM/DD/YYYY");
        
        if (dateA < dateB) {
            return -1;
        }
        if (dateA > dateB) {
            return 1;
        }
        return 0;
    }

    const compareBlackoutDate = (a, b) => {
        const dateA = moment(a.date, "MM/DD/YYYY");
        const dateB = moment(b.date, "MM/DD/YYYY");
        
        if (dateA < dateB) {
            return -1;
        }
        if (dateA > dateB) {
            return 1;
        }
        return 0;
    }

    switch (action.type) {
        case PTO_SETTING: {
            return {
                ...state,
                settings: action.settings
            }
        }
        case PTO_TYPE_GET_LIST: {
            return {
                ...state,
                typeList: action.list
            }
        }
        case PTO_TYPE_CREATE: {
            let newList = [...state.typeList];
            if (action.ptoTypeObj.id) {
                newList.push({...action.ptoTypeObj})
            }
            newList.sort(comparePTOType);

            return {
                ...state,
                typeList: newList
            }
        }
        case PTO_TYPE_UPDATE: {
            let newList = state.typeList.map(ptoType => {
                if (ptoType.id === action.ptoTypeObj.id) {
                    return {...action.ptoTypeObj}
                }
                return {...ptoType}
            });
            newList.sort(comparePTOType);

            return {
                ...state,
                typeList: newList
            }
        }
        case PTO_TYPE_DELETE: {
            let newList = state.typeList.filter(ptoType => 
                ptoType.id !== action.ptoTypeId
            );

            return {
                ...state,
                typeList: newList
            }
        }
        case PTO_REASON_GET_LIST: {
            return {
                ...state,
                reasonList: action.list
            }
        }
        case PTO_REASON_CREATE: {
            let newList = [...state.reasonList];
            if (action.ptoReasonObj.id) {
                newList.push({...action.ptoReasonObj})
            }
            newList.sort(comparePTOReason);

            return {
                ...state,
                reasonList: newList
            }
        }
        case PTO_REASON_UPDATE: {
            let newList = state.reasonList.map(ptoReason => {
                if (ptoReason.id === action.ptoReasonObj.id) {
                    return {...action.ptoReasonObj}
                }
                return {...ptoReason}
            });
            newList.sort(comparePTOReason);

            return {
                ...state,
                reasonList: newList
            }
        }
        case PTO_REASON_DELETE: {
            let newList = state.reasonList.filter(ptoReason => 
                ptoReason.id !== action.ptoReasonId
            );

            return {
                ...state,
                reasonList: newList
            }
        }
        case HOLIDAY_GET_LIST: {
            return {
                ...state,
                holidayList: action.list
            }
        }
        case HOLIDAY_CREATE: {
            let newList = [...state.holidayList];
            if (action.holidayObj.id) {
                newList.push({...action.holidayObj})
            }

            return {
                ...state,
                holidayList: newList
            }
        }
        case HOLIDAY_UPDATE: {
            let newList = state.holidayList.map(holiday => {
                if (holiday.id === action.holidayObj.id) {
                    return {...action.holidayObj}
                }
                return {...holiday}
            });

            return {
                ...state,
                holidayList: newList
            }
        }
        case HOLIDAY_DELETE: {
            let newList = state.holidayList.filter(holiday => 
                holiday.id !== action.holidayId
            );

            return {
                ...state,
                holidayList: newList
            }
        }
        case ASSIGNED_HOLIDAY_GET_LIST: {
            return {
                ...state,
                assignedHolidayList: action.list
            }
        }
        case HOLIDAY_CREATE_ASSIGNMENT: {
            let newList = [...state.assignedHolidayList];
            if (action.holidayObj.id) {
                newList.push({...action.holidayObj})
            }

            return {
                ...state,
                assignedHolidayList: newList
            }
        }
        case HOLIDAY_UPDATE_ASSIGNMENT: {
            let newList = state.assignedHolidayList.map(holiday => {
                if (holiday.id === action.holidayObj.id) {
                    return {...action.holidayObj}
                }
                return {...holiday}
            });

            return {
                ...state,
                assignedHolidayList: newList
            }
        }
        case TIMEOFF_REQUEST_LIST: {
            return {
                ...state,
                timeoffRequestList: action.list
            }
        }
        case CREATE_TIMEOFF_REQUEST: {
            let newList = [...state.timeoffRequestList];
            let newLeaveList = [...state.leaveList];
            if (action.requestObj.id) {
                newList.push({...action.requestObj})
                newLeaveList.push({...action.requestObj})
            }

            return {
                ...state,
                timeoffRequestList: newList,
                leaveList: newLeaveList
            }
        }
        case MODIFY_TIMEOFF_REQUEST: {
            // will be executed when staff modified his request
            let newList = state.timeoffRequestList.map(request => {
                if (request.id === action.requestObj.id) {
                    return {...action.requestObj};
                }
                return {...request};
            });

            let newLeaveList = state.leaveList.map(leave => {
                if (leave.id === action.requestObj.id) {
                    return {...action.requestObj};
                }
                return {...leave};
            });

            return {
                ...state,
                timeoffRequestList: newList,
                leaveList: newLeaveList
            }
        }
        case DELETE_TIMEOFF_REQUEST: {
            // will be executed when staff deleted his request
            let newList = state.timeoffRequestList.filter(request => 
                request.id !== action.requestId
            );
            let newLeaveList = state.leaveList.filter(leave => 
                leave.id !== action.requestId
            );

            return {
                ...state,
                timeoffRequestList: newList,
                leaveList: newLeaveList
            }
        }
        case GET_PENDING_REQUESTS: {
            return {
                ...state,
                pendingRequestList: action.list
            }
        }
        case GET_PENDING_REQUEST_DATA: {
            let newList = state.pendingRequestList.map(request => {
                if (request.id === action.requestObj.id) {
                    return {...action.requestObj}
                }
                return {...request}
            });
            return {
                ...state,
                pendingRequestList: newList
            }
        }
        case UPDATE_PENDING_REQUESTS: {
            let newList = state.pendingRequestList.filter(request => 
                request.id !== action.requestObj.id || 
                action.requestObj.status === WAITING_FOR_APPROVAL
            );
            
            if (action.requestObj.status === WAITING_FOR_APPROVAL) {
                newList = state.pendingRequestList.map(request => {
                    if (request.id === action.requestObj.id) {
                        return {...action.requestObj};
                    }
                    return {...request};
                }); 
            } 
            
            return {
                ...state,
                pendingRequestList: newList
            }
        }
        case USER_PTO_INFO_LIST: {
            return {
                ...state,
                ptoInfoList: action.list
            }
        }
        case STAFF_PTO_INFO: {
            return {
                ...state,
                staffPTOInfo: action.data
            }
        }
        case LEAVE_LIST: {
            return {
                ...state,
                leaveList: action.list
            }
        }
        case BIRTHDAY_LIST: {
            return {
                ...state,
                birthDayList: action.list
            }
        }
        case USER_REQUEST_LIST: {
            return {
                ...state,
                userRequestList: action.list
            }
        }
        case STAFF_ALLOWED_LIST: {
            return {
                ...state,
                staffAllowedList: action.list
            }
        }
        case UPDATE_STAFF_ALLOWED_LIST: {
            let updatedList = state.staffAllowedList.map(obj => {
                if(obj.id === action.obj.id) {
                    return {...action.obj}
                } 
                return {...obj};
            });

            return {
                ...state,
                staffAllowedList: updatedList
            }
        }
        case GET_BLACKOUT_DAY_LIST: {
            return {
                ...state,
                blackoutDayList: action.response
            }
        }
        case POST_BLACKOUT_DAY: {
            let newList = [...state.blackoutDayList];
            if (action.response.id) {
                newList.push({...action.response})
            }
            newList.sort(compareBlackoutDate);

            return {
                ...state,
                blackoutDayList: newList
            }
        }
        case UPDATE_BLACKOUT_DAY: {
            let newList = state.blackoutDayList.map(blackoutDay => {
                if (blackoutDay.id === action.response.id) {
                    return {...action.response}
                }
                return {...blackoutDay}
            });
            newList.sort(compareBlackoutDate);

            return {
                ...state,
                blackoutDayList: newList
            }
        }
        case DELETE_BLACKOUT_DAY: {
            let newList = state.blackoutDayList.filter(blackoutDay => 
                blackoutDay.id !== action.blackoutDayId
            );

            return {
                ...state,
                blackoutDayList: newList
            }
        }

        default:
            return state;
    }
};

export default PTOReducer;



// WEBPACK FOOTER //
// ./src/reducers/PTOReducer.js